import React, { Component } from 'react';
import Checkbox from '@material-ui/core/Checkbox';

export const datefor = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
});

export default class Job extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: null,
            checked: false,
        };
        this.handleAllCheckChange = this.handleAllCheckChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            job: this.props.job,
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.job !== this.props.job) {
            this.setState({
                job: this.props.job,
            });
        }
    }

    handleAllCheckChange(job) {
        job.checked = !job.checked;
        this.setState({ job: job });
        this.props.jobActionPerformed(job);
    }

    renderDetailsRow() {
        var hideLastInwardedTime = this.props.hideProductHeader;
        return (
            <div className="row">
                <div className="col-xs-6 col-md-2">
                    <div
                        className="putaway-product-label"
                        style={{
                            marginTop: '15px',
                        }}
                    >
                        Current Location
                    </div>
                    <div
                        className="putaway-product-value"
                        style={{
                            marginTop: '8px',
                        }}
                    >
                        {
                            this.state.job
                                .fromSpace
                                .spaceDisplayName
                        }
                    </div>
                </div>
                <div className="col-xs-6 col-md-2 no-right-padding">
                    <div
                        className="putaway-product-label"
                        style={{
                            marginTop: '15px',
                        }}
                    >
                        Quantity to transfer
                    </div>
                    <div
                        className="putaway-product-value"
                        style={{
                            marginTop: '8px',
                        }}
                    >
                        {
                            this.state.job
                                .qtyToTransfer
                        }
                    </div>
                </div>
                <div className={hideLastInwardedTime ? 'col-xs-6 col-md-8 no-xs-padding-left-thirty' : 'col-xs-6 col-md-6 no-xs-padding-left-thirty'}>
                    <div
                        className="putaway-product-label"
                        style={{
                            marginTop: '15px',
                        }}
                    >
                        Put away location
                    </div>
                    <div
                        className="putaway-product-value"
                        style={{
                            marginTop: '8px',
                        }}
                    >
                        {
                            this.state.job
                                .toSpace
                                .spaceDisplayName
                        }
                    </div>
                </div>
                {!hideLastInwardedTime ? (
                    <div className="col-xs-6 col-md-2 no-padding">
                        <div
                            className="putaway-product-label"
                            style={{
                                marginTop: '15px',
                            }}
                        >
                            Last Inwarded Time
                        </div>
                        <div
                            className="putaway-product-value"
                            style={{
                                marginTop: '8px',
                            }}
                        >
                            {datefor.format(
                                this.state.job
                                    .lastInwardedTime
                            )}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        var hideProductHeader = this.props.hideProductHeader;
        return (
            <div>
                {this.state.job ? (
                    <div className={hideProductHeader ? '' : 'top-thirty'}>
                        <div className={hideProductHeader ? '' : 'putaway-product'}>
                            <div className="row">
                                <div
                                    className="col-xs-2 col-md-1"
                                    style={hideProductHeader ? {} : { marginTop: '40px' }}
                                >
                                    <Checkbox
                                        checked={this.state.job.checked}
                                        onChange={() =>
                                            this.handleAllCheckChange(
                                                this.state.job
                                            )
                                        }
                                        value="checkedG"
                                        classes={{
                                            root: 'cstmCheckBox',
                                            checked: 'greenChecked',
                                        }}
                                    />
                                </div>
                                <div className="col-xs-10 col-md-11">
                                    {hideProductHeader ? (
                                        this.renderDetailsRow()
                                    ) : (
                                        <div className="row">
                                            <div className="col-xs-4 col-md-2 no-left-padding">
                                                <img
                                                    src={
                                                        this.state.job
                                                            .productDetails
                                                            .imageUrlList[0]
                                                    }
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '100px',
                                                    }}
                                                    alt="product"
                                                />
                                            </div>
                                            <div className="col-md-10 no-left-padding">
                                                <div className="row">
                                                    <div
                                                        className="col-md-12"
                                                        style={{
                                                            fontSize: '16px',
                                                            color: '#212121',
                                                            lineHeight: '22px',
                                                        }}
                                                    >
                                                        {
                                                            this.state.job
                                                                .productDetails
                                                                .title
                                                        }
                                                    </div>
                                                </div>
                                                {this.renderDetailsRow()}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/Job.js